import NumberInput from './NumberInput';
import './NumberInput.scss';

export default NumberInput;
